var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#27D397",
    strokeWidth: 2,
    transform: "translate(-855 -506) translate(352 389) translate(504 118)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#27D397",
    fillRule: "nonzero",
    d: "M15.789 7.745c-.463-.46-1.21-.46-1.672 0l-4.256 4.256-1.842-1.841c-.293-.321-.739-.455-1.16-.35-.422.106-.751.434-.859.856-.107.42.026.867.346 1.161l2.678 2.678c.462.461 1.21.461 1.672 0l5.091-5.093c.461-.462.461-1.21 0-1.672l.002.005z",
    transform: "translate(-855 -506) translate(352 389) translate(504 118)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/checkmark-green.195dfdee8036dfc1a88b1a403e996e94.svg";
export { ForwardRef as ReactComponent };